<script>
/**
 * The MatchTeamGameRoster view works for the roster setting for each team 
 * of the game. 
 */

//--------------------------------------------------
// imported classes
//--------------------------------------------------
import Vue from 'vue'
import { ActionSheet, Toast, Field, Dialog } from 'vant'
import { QNImageUtil } from '@/utils'
import { getPassport } from '@/libs/passport'
import { getMatchGameTeamStartingList, updateMatchGameTeamStartingList } from '@/api/match-team-game'
import FooterBtn from './footer-btn.vue'
//--------------------------------------------------
// global registration
//--------------------------------------------------
Vue.use(ActionSheet).use(Toast).use(Field)

//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'match-team-game-roster',
    components: {
        FooterBtn
    },
    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            /* The starter max number */
            starterMaxNum: 0,
            /**
             * The bench player max number 
             * If value equals zero, it means no limit for substitute.
             */
            benchMaxNum: 0,
            /**
             * The player list contains player id, name, number, avatar and status.
             * The status property means starter(1), bench(2) and none 
             * playing(3).
             */
            playerList: [],
            /**
             * The selected order type
             * The type value means by default(0) or name(1).
             */
            selectedSortType: 0,
            /* The show sort options boolean status by show(true) or hide(false) */
            showSortOptions: false,
            /* The sort option list */
            sortOptionList: [
                { name: '默认排序' },
                { name: '球员姓名' },
            ],
            /* The boolean status for click action for the sort options */
            isCloseOnClickAction: true,
            /* The shirt color string */
            shirtColor: null,
            /* The short color string */
            shortColor: null,
            /* The sock color string */
            sockColor: null,
            /* The captain player id */
            captainPlayerId: null,
            /* The goalkeeper player id */
            goalkeeperPlayerId: null,
            lockListOnStage: 0
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the starter num label.
         */
        starterNumLabel() {
            return this.getStarterLength() + '/' + this.starterMaxNum
        },
        /**
         * @getter
         * Get the bench num label.
         */
        benchNumLabel() {
            return this.getBenchLength() + (this.benchMaxNum == 0 ? '' : ('/' + this.benchMaxNum))
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        //--------------------------------------------------
        // request method
        //--------------------------------------------------
        /**
         * @request
         * Query the roster player for each team of the game.
         * @return The reponse object.
         */
		queryRosterList() {
            console.log('requestRosterList')
            const routerParams = this.$route.params
            const params = {
                matchId: routerParams.matchId,
                teamId: routerParams.teamId,
                gameId: routerParams.gameId
            }
            getMatchGameTeamStartingList(params).then(response => {
                console.log('match game team starting list data', response.data)
                const data = response.data
                // set the data
                this.starterMaxNum = data.gameInfo.gameType.replace(/[^0-9]/g, "")
                // data.gameInfo.substituteLimitOpen = 1;
                // data.gameInfo.substituteMaxCount = 3;

                if (data.gameInfo.substituteLimitOpen == 0) {
                    this.benchMaxNum = 0
                }
                else if (data.gameInfo.substituteLimitOpen == 1 && data.gameInfo.substituteMaxCount) {
                    this.benchMaxNum = data.gameInfo.substituteMaxCount
                }
                
                // set the player list
                let players = [];
                for (let i = 0; i < data.list.length; i++) {
                    var player = data.list[i]
                    players.push({
                        id: player.id,
                        name: player.trueName,
                        number: player.number ? parseInt(player.number) : null,
                        avatar: player.avatar,
                        status: player.isStarting == 1 ? 1 : (player.isStarting == 0 ? 2 : 3) 
                    })
                    if (player.isCaptain == 1) {
                        this.captainPlayerId = player.id
                    }
                    if (player.isGoalkeeper == 1) {
                        this.goalkeeperPlayerId = player.id
                    }
                }
                this.playerList = players
                this.sortPlayerList()

                // clothes color - set shirtColor, shortColor, sockColor
                const clothesColorDesc = data.clothes.clothesColorDescription
                const clothesColors = data.clothes.clothesColors
                if (clothesColors) {
                    try {
                        const jsonData = JSON.parse(clothesColors)
                        this.shirtColor = jsonData.shirtColor
                        this.shortColor = jsonData.shortColor
                        this.sockColor = jsonData.sockColor
                    }
                    catch (e) {
                        console.log(e)
                    }
                }
                else if (clothesColorDesc) {
                    let teamStr = '主场'
                    if (routerParams.teamId == data.gameInfo.awayTeamId) {
                        teamStr = '客场'
                    }
                    const teamShirt = teamStr + '上衣'
                    const teamShort = teamStr + '短裤'
                    const teamSock = teamStr + '球袜'
                    const clothesColorArr = clothesColorDesc.split(',')
                    for (let i = 0; i < clothesColorArr.length; i++) {
                        const clothesColorItem = clothesColorArr[i]
                        const clothesColorItemEle = clothesColorItem.split(':')
                        if (clothesColorItemEle.length == 2) {
                            if (clothesColorItemEle[0] == teamShirt) {
                                this.shirtColor = clothesColorItemEle[1]
                            }
                            else if (clothesColorItemEle[0] == teamShort) {
                                this.shortColor = clothesColorItemEle[1]
                            }
                            else if (clothesColorItemEle[0] == teamSock) {
                                this.sockColor = clothesColorItemEle[1]
                            }
                        }
                    }
                }
            })
        },
        back() {
            this.$router.go(-1)
        },
        onCaptainBtnClick(player) {
            if (this.lockListOnStage == 1) {
                return
            }
            if(player.status != 1) return
            this.captainPlayerId = player.id == this.captainPlayerId ? null : player.id
        },
        onGoalkeeperBtnClick(player) {
            if (this.lockListOnStage == 1) {
                return
            }
            if(player.status != 1) return
            this.goalkeeperPlayerId = player.id == this.goalkeeperPlayerId ? null : player.id
        },
        /**
         * @request
         * Update the roster player starting status.
         * @param starters The starter player ids.
         * @param benchs The bench player ids.
         * @return The reponse object.
         */
        updateRosterList(starters, benchs) {
            const routerParams = this.$route.params
            const params = {
                matchId: routerParams.matchId,
                teamId: routerParams.teamId,
                gameId: routerParams.gameId
            }
            const clothesColors = {}
            if (this.shirtColor) {
                clothesColors.shirtColor = this.shirtColor
            }
            if (this.shortColor) {
                clothesColors.shortColor = this.shortColor
            }
            if (this.sockColor) {
                clothesColors.sockColor = this.sockColor
            }
            const data = {
                starting: starters.join(','),
                substitution: benchs.join(','),
                // clothesColors: JSON.stringify(clothesColors),
                captainPlayerId: this.captainPlayerId,
                goalkeeperPlayerId: this.goalkeeperPlayerId
            }
            updateMatchGameTeamStartingList(params, data).then(res => {
                console.log('updateMatchGameTeamStartingList', res)
                // back to the landing page
                this.$router.go(-1)
            })
        },

        //--------------------------------------------------
        // setter and getter
        //--------------------------------------------------
		/**
         * @getter
         * Get the starter length within the player list.
         * @return The length number
         */
         getStarterLength() {
            let starterLength = 0
            for (let i = 0; i < this.playerList.length; i++) {
                let player = this.playerList[i]
                if (player.status === 1) {
                    starterLength++
                }
            }
            return starterLength
        },
        /**
         * @getter
         * Get the bench length within the player list.
         * @return The length number
         */
        getBenchLength() {
            let benchLength = 0
            for (let i = 0; i < this.playerList.length; i++) {
                let player = this.playerList[i]
                if (player.status === 2) {
                    benchLength++
                }
            }
            return benchLength
        },

        //--------------------------------------------------
        // handler method
        //--------------------------------------------------
        /**
         * @handler
         * Handle the sort option select event.
         */
        onSortOptionSelect(item, index) {
            console.log('onSelect', item, index)
            this.selectedSortType = index
            this.sortPlayerList()
        },
        /**
         * @handler
         * Handle the sort button click event.
         */
        onSortButtonClick(e) {
            console.log('onSortButtonClick', e)
            this.showSortOptions = true
        },
        /**
         * @handler
         * Handle the submit event.
         */
        onSubmit() {
            console.log('this.playerList', this.playerList)
            let starters = []
            let benchs = []
            for (let i = 0; i < this.playerList.length; i++) {
                let player = this.playerList[i]
                if (player.status == 1) {
                    starters.push(player.id)
                }
                else if (player.status == 2) {
                    benchs.push(player.id)
                }
            }
            if (!this.captainPlayerId || !this.goalkeeperPlayerId) {
                let message = ''
                if(!this.captainPlayerId && !this.goalkeeperPlayerId) {
                    message = '请选择队长和守门员'
                } else if (!this.captainPlayerId) {
                    message = '请选择队长'
                } else if (!this.goalkeeperPlayerId) {
                    message = '请选择守门员'
                }
                Dialog({
                    title: '提醒',
                    message: message,
                    className: 'roster-submit-dialog'
                })
                return
            }
            // validate the starter number equals max or not
            if (starters.length < this.starterMaxNum) {
                Dialog.confirm({
                    title: '提醒',
                    message: '首发人数少于' + this.starterMaxNum + '人，是否确认提交',
                    className: 'roster-submit-dialog'
                }).then(() => {
                    // on confirm
                    this.updateRosterList(starters, benchs)
                }).catch(() => {
                    // on cancel
                });
            }
            else {
                this.updateRosterList(starters, benchs)
            }
        },
        /**
         * @handler
         * Handle the starter button click event.
         */
        onStarterBtnClick(player) {
            if (this.lockListOnStage == 1) {
                return
            }
            // validate the original status
            if (player.status == 1) {
                player.status = 0
                if (this.captainPlayerId == player.id) {
                    this.captainPlayerId = null
                }
                if (this.goalkeeperPlayerId == player.id) {
                    this.goalkeeperPlayerId = null
                }
                // if no change, return
                return
            }

            // fetch the current starter length
            const starterLength = this.getStarterLength()
            // validate the starter max num with the current length
            if (starterLength == this.starterMaxNum) {
                // prompt the excceed message
                Toast('首发人数已经达到' + this.starterMaxNum + '人！')
            }
            else {
                // change the status anyway
                player.status = 1;
            }
        },
        /**
         * @handler
         * Handle the bench button click event.
         */
        onBenchBtnClick(player) {
            if (this.lockListOnStage == 1) {
                return
            }
            // validate the original status
            if (player.status == 2) {
                // if no change, return
                player.status = 0
                if (this.captainPlayerId == player.id) {
                    this.captainPlayerId = null
                }
                if (this.goalkeeperPlayerId == player.id) {
                    this.goalkeeperPlayerId = null
                }
                return
            }

            // fetch the current bench length
            const benchLength = this.getBenchLength()
            // validate the starter max num with the current length
            if (this.benchMaxNum > 0 && benchLength == this.benchMaxNum) {
                // prompt the excceed message
                Toast('替补人数已经达到' + this.benchMaxNum + '人！')
            }
            else {
                // change the status anyway
                player.status = 2;
            }
        },

        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
			return QNImageUtil.imageView(img, w, h)
		},
        /**
         * @private
         * Sort the player list with default(0) or name(1) mode via selected 
         * sort type.
         */
        sortPlayerList() {
            if (this.selectedSortType === 0) {
                this.playerList.sort(function(a, b) {
                    if (a.number && b.number) {
                        return a.number - b.number
                    }
                    else if (a.number == null && b.number) {
                        return 1
                    }
                    else if (a.number && b.number == null) {
                        return -1
                    }
                    else {
                        return a.id - b.id
                    }
                })
            }
            else if (this.selectedSortType === 1) {
                this.playerList.sort(function(a, b) {
                    return a.name.localeCompare(b.name)
                })
            }
        }
    },
    /**
     * @created
     * Set the data model via the match id, team id, game id and passport.
     * Query the game roster data according to the params and cookies.
     * All parameters are required. 
     * Use getPassport to ensure the authentication status.
     */
    created() {
        this.lockListOnStage = Number(this.$route.query.lockListOnStage)
        // validate the passport and prepair the one
        getPassport().then(res => {
            console.log('getPassport', res)
            if (res) {
                this.queryRosterList()
            }
        })
	}
}
</script>

<template>
    <!-- component -->
    <div class="match-team-game-roster">
        <!-- clothes-color start -->
        <div class="clothes-color" v-if="false">
            <div class="title-section">
                <div class="unit">
                    <span class="label">比赛服颜色</span>
                </div>
            </div>
            <div class="content-section">
                <div class="clothes-type-item">
                    <div class="label-unit">
                        <img src="@/assets/match-team-game/shirt-icon.svg"/>
                        <span class="label">上衣</span>
                    </div>
                    <div class="input-unit">
                        <van-field v-model="shirtColor" placeholder="上衣颜色">
                        </van-field>
                    </div>
                </div>
                <div class="clothes-type-item">
                    <div class="label-unit">
                        <img src="@/assets/match-team-game/short-icon.svg"/>
                        <span class="label">球裤</span>
                    </div>
                    <div class="input-unit">
                        <van-field v-model="shortColor" placeholder="球裤颜色">
                        </van-field>
                    </div>
                </div>
                <div class="clothes-type-item">
                    <div class="label-unit">
                        <img src="@/assets/match-team-game/sock-icon.svg"/>
                        <span class="label">球袜</span>
                    </div>
                    <div class="input-unit">
                        <van-field v-model="sockColor" placeholder="球袜颜色">
                        </van-field>
                    </div>
                </div>
            </div>
        </div>
        <!-- clothes-color end -->
        <!-- player-roster start -->
        <div class="player-roster">
            <div class="title-section">
                <div class="summary-section">
                    <div class="starter">
                        <div class="label">首发：</div>
                        <div class="value">{{ starterNumLabel }}</div>
                        <div class="unit">人</div>
                    </div>
                    <div class="bench">
                        <div class="label">替补：</div>
                        <div class="value">{{ benchNumLabel }}</div>
                        <div class="unit">人</div>
                    </div>
                </div>
                <div class="operation-section">
                    <div class="sort-btn" @click="onSortButtonClick">
                        <span class="label">默认排序</span>
                        <img src="@/assets/match-team-game/down-symbol.svg"/>
                    </div>
                </div>
            </div>
            <div class="content-section-top-title">
                <div class="right-title">
                    <div>首发</div>
                    <div>替补</div>
                    <div>队长</div>
                    <div>守门员</div>
                </div>
            </div>
            <div class="content-section">
                <div class="player-list">
                    <div class="player-item" 
                        v-for="player in playerList" 
                        :key="player.id">
                        <div class="player-info inline-block">
                            <div class="avatar inline-block">
                                <img v-if="player.avatar" :src="adjustImageSize(player.avatar, 60, 80)"/>
                                <img v-else src="@/assets/match-team-game/avatar-symbol.svg"/>
                            </div>
                            <div class="name-section inline-block valign-top">
                                <div class="name-label truncate">{{ player.name }}</div>
                                <div v-if="player.number" class="num inline-block valign-top">
                                    <div class="no-wrapper">
                                        <span class="num-label block">{{ player.number }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="operation-bar inline-block valign-top">
                            <div class="inline-block checkbox" @click="onStarterBtnClick(player)" :class="{ disabled: lockListOnStage == 1 }">
                                <img v-if="player.status == 1" src="@/assets/match-team-game/checkbox-square-activation.svg" />
                                <img v-else  src="@/assets/match-team-game/checkbox-square.svg" />
                            </div>
                            <div class="inline-block checkbox" @click="onBenchBtnClick(player)" :class="{ disabled: lockListOnStage == 1 }">
                                <img v-if="player.status == 2" src="@/assets/match-team-game/checkbox-square-activation.svg" />
                                <img v-else  src="@/assets/match-team-game/checkbox-square.svg" />
                            </div>
                            <div class="inline-block checkbox" :class="{ disabled: player.status != 1 || lockListOnStage == 1 }" @click="onCaptainBtnClick(player)">
                                <img v-if="player.id == captainPlayerId" src="@/assets/match-team-game/checkbox-round-activation.svg" />
                                <img v-else  src="@/assets/match-team-game/checkbox-round.svg" />
                            </div>
                            <div class="inline-block checkbox" :class="{ disabled: player.status != 1 || lockListOnStage == 1 }" @click="onGoalkeeperBtnClick(player)">
                                <img v-if="player.id == goalkeeperPlayerId" src="@/assets/match-team-game/checkbox-round-activation.svg" />
                                <img v-else  src="@/assets/match-team-game/checkbox-round.svg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- player-roster end -->
        <!-- footer start -->
        <div class="footer" v-if="lockListOnStage == 0">
            <div class="fixed-layer">
                <div class="btn-wrapper">
                    <div class="submit-btn" @click="onSubmit">提交</div>
                </div>
            </div>
        </div>
        <div v-else>
            <FooterBtn btnText="返回" showDisable disableLabel="无法更新" disableValue="比赛已检录，无法更新出场信息" @click="back" />
        </div>
        <!-- footer end -->
        <!-- bottom popup start -->
        <div class="bottom-popup">
            <van-action-sheet
                v-model="showSortOptions"
                :actions="sortOptionList"
                @select="onSortOptionSelect"
                title="球员排序"
                :close-on-click-action="isCloseOnClickAction">
                <template slot="default">
                    <div class="popup-desc">请选择球员排序</div>
                </template>
            </van-action-sheet>
        </div>
        <!-- bottom popup end -->
    </div>
</template>

<style scoped lang="scss">
#app {
    background: #F0F0F3;
    height: 100vh;
}
/**
 * Common
 */
.inline-block {
    display: inline-block;
}
.block {
    display: block;
}
.valign-top {
    vertical-align: top;
}
.truncate {
	word-break: break-all;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
/**
 * @component
 */
.match-team-game-roster {
    /* background: #F0F0F3; */
    overflow-x: hidden;
    min-height: 100vh;
}
/**
 * @clothes-color
 */
.clothes-color .title-section {
    height: 38px;
    background: #F0F0F3;
}
.content-section-top-title{
   padding-top: 8px;
//    padding-bottom: 12px;
   height: 22px;
   .right-title{
        position: absolute;
        right: 20px;
        color: #9E9E9E;
        font-size: 13px;
        div{
            display: inline-block;
            width: 40px;
            text-align: center;
            margin-left: 7px;
        }
   }

}
.clothes-color .title-section .unit {
    padding: 10px 16px 8px 16px;
}
.clothes-color .title-section .label {
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: 350;
    line-height: 13px;
    letter-spacing: normal;
    color: #676767;
}
.clothes-color .content-section {
    margin-left: 23px;
    margin-top: 24px;
}
.clothes-type-item {
    display: inline-block;
    width: 92px;
    margin-right: 23px;
}
.clothes-type-item .label-unit img {
    margin-left: 3px;
}
.clothes-type-item .label-unit .label {
    margin-left: 3px;
    font-family: PingFang SC;
    font-size: 15px;
    font-weight: normal;
    line-height: 15px;
    letter-spacing: normal;
    color: #1D2129;
}
.clothes-type-item .input-unit {
    margin-top: 5px;
    width: 92px;
    border-radius: 2px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #DCDDE1;
}
.clothes-type-item .input-unit input {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 14px;
    letter-spacing: normal;
    color: var(--el-color-text-primary); /* #303133 */
}
/**
 * @player-roster
 */
.player-roster .title-section {
    // margin-top: 15px;
    width: 100%;
    height: 36px;
    background: #F0F0F3;
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: 350;
    line-height: 13px;
    display: flex;
    align-items: center;
    letter-spacing: normal;
    color: #676767;
}
.player-roster .title-section div {
    display: inline-block;
}
.summary-section {
    margin: 10px 16px 8px 16px;
    width: 238px;
}
.bench {
    margin-left: 36px;
}
.operation-section {
    margin-right: 8px;
    text-align: center;
    width: 97px;
    height: 100%;
    box-sizing: border-box;
    border: 3px solid #F0F0F3;   /* #57C1BB */
}
.sort-btn {
    padding-top: 10px;
}
.sort-btn .label {
    margin-right: 6px;
}
.avatar img {
    width: 30px;
    height: 40px;
}
.player-item {
    height: 41px;
    padding: 18px 20px 14px 20px;
    width: 100%;
    border-bottom: 1px solid #F0F0F3;
    background: #FFFFFF;
}
.name-section {
    margin-left: 8px;
}
.name-label {
    margin-bottom: 7px;
    font-family: Source Han Sans;
    font-size: 15px;
    font-weight: 500;
    line-height: 15px;
    align-items: center;
    letter-spacing: normal;
    color: #4D4D4D;
    max-width: 140px;
}
.no-wrapper {
    width: 15px;
    height: 15px;
    border-radius: 2px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #0FAC7F;
    align-content: center;
    align-items: center;
    vertical-align: middle;
}
.num-label {
    font-family: AlibabaPuHuiTi;
    font-size: 11px;
    font-weight: normal;
    line-height: 11px;
    text-align: center;
    letter-spacing: normal;
    color: #3D3D3D;
}
.operation-bar {
    height: 41px;
    position: absolute;
    right: 20px;
    .checkbox{
        width: 40px;
        text-align: center;
        margin-left: 7px;
    }
    .disabled{
        opacity: 0.5;
    }
}
.roster-op-btn {
    margin-left: 6px;
    padding-top: 3px;
    width: 47px;
    height: 24px;
    border-radius: 2px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #D8D8D8;
    font-family: Source Han Sans;
    font-size: 10px;
    font-weight: 350;
    line-height: 17px;
    text-align: center;
    letter-spacing: normal;
    color: #979797;
}
.roster-op-btn.active {
    background: #0FAC7F;
    font-family: Source Han Sans;
    font-weight: 500;
    color: #FFFFFF;
}
/**
 * @footer
 */
.footer {
    height: 65px;
}
.fixed-layer {
    height: 65px;
    position: fixed;
    width: 100%;
    bottom: 0;
    background: #FFFFFF;
}
.btn-wrapper {
    height: 45px;
    margin: 10px 15px;
    border-radius: 6px;
    background: #0FAC7F;
    text-align: center;
    /**
     * avoid the compatiable issue on the app
     * NOT: align-content: center;
     * BUT: line-height: 1;
     */
    line-height: 45px;
}
.submit-btn {
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: normal;
    color: #FFFFFF;
}
/**
 * @bottom-popup
 */
.van-popup {
    background: #F9F9F9;
}
.van-icon-cross:before {
    content: none;
}
.van-action-sheet__header {
    margin-top: 8px;
    height: 65px;
    font-family: Source Han Sans;
    font-size: 17px;
    font-weight: 500;
    line-height: 31px;
    text-align: center;
    align-items: center;
    letter-spacing: 0.32px;
    color: #333333;
}
.popup-desc {
    position: absolute;
    top: 44px;
    width: 100%;
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: normal;
    line-height: 22px;
    text-align: center;
    align-items: center;
    letter-spacing: 0.32px;
    color: #777777;
}
.van-action-sheet__item {
    padding: 20px 16px 10px 16px;
    background: #F9F9F9;
    box-sizing: border-box;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #E5E5E5;
}
.van-action-sheet__name {
    font-family: Source Han Sans;
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    letter-spacing: normal;
    color: #4D4D4D;
}
.van-action-sheet__content {
    margin-bottom: 10px;
}
</style>
<style>
/**
 * Dialog
 */
.van-dialog {
    border-radius: 4px;
}
.van-dialog__header {
    padding-top: 23px;
    font-family: Source Han Sans;
    font-size: 17px;
    font-weight: 500;
    line-height: 15px;
    letter-spacing: normal;
    color: #4D4D4D;
}
.van-dialog__message--has-title {
    padding-top: 20px;
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: normal;
    line-height: 15px;
    letter-spacing: normal;
    color: #4D4D4D;
}
.van-dialog__cancel {
    height: 36px;
    border-radius: 108px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #0FAC7F;
}
.van-dialog__cancel .van-button__text {
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: normal;
    line-height: 35px;
    letter-spacing: 0.2px;
    color: #0FAC7F;
}
.van-dialog__confirm {
    margin-left: 15px;
    height: 36px;
    border-radius: 108px;
    background: #0FAC7F;
}
.van-dialog__confirm .van-button__text {
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: normal;
    line-height: 35px;
    letter-spacing: 0.2px;
    color: #FFFFFF;
}
.van-dialog__footer {
    margin: 11px 9px 19px 9px;
}
</style>